<style scoped> 
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="form-group">
        <label :class="['label', { 'required': required }]" > {{ label }} </label>
        <app-input 
            :placeholder= "'Select ' + label" 
            type="advance-search-select"
            :fetch-url="url" 
                        v-model="selected" 
                        :listValueField="listValueField"
                        :loaded-per-time="5" 
                        :required="required"
                        :disabled="is_view"   
                    />
    </div>
</template>
  
<script>
    export default {
        name: 'SelectHttps',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            is_view : {
                type : Boolean,
                default : false
            },
            label : {
                type : String,
                default : ''
            },
            required : {
                type :Boolean,
                default : false,
            },
            url : {
                type : String,
                default : '',
            },
            listValueField : {
                type : String,
                default : '',
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>